import {Component, OnInit} from '@angular/core';
import {Country} from '../../../kf-data-entry/models/country.interface';
import {WeeeSystems} from '../../../admin/models/weee_systems.interface';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {DownloadDataService} from '../../../core/services/download-data.service';
import {IntelligenceService} from '../../services/intelligence.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-download-at-a-glance',
  templateUrl: './download-at-a-glance.component.html',
  styleUrls: ['./download-at-a-glance.component.scss']
})
export class DownloadAtAGlanceComponent implements OnInit {

  years!: number[];
  countries!: Country[];
  weeeSystems!: WeeeSystems[];


  downloadDataForm = this.formBuilder.group({
    years: ['', Validators.required],
    countries: [''],
  });

  get yearsControl(): FormControl {
    return this.downloadDataForm.get('years') as FormControl;
  }
  get countriesControl(): FormControl {
    return this.downloadDataForm.get('countries') as FormControl;
  }

  constructor(private readonly formBuilder: FormBuilder,
              private readonly downloadDataService: DownloadDataService,
              private readonly intelligenceService: IntelligenceService) { }

  ngOnInit(): void {
    this.intelligenceService.getYears().subscribe(data => {
      this.years = data;
      this.yearsControl.setValue(data[0]);
    });
    this.downloadDataService.getAllCountries().subscribe(data => this.countries = data);
  }

  sendCreationRequest(): void {
  }

  downloadData(): void {
    this.downloadDataService
      .downloadIntelligenceExcel({years: this.yearsControl.value, countries: this.countriesControl.value})
      .subscribe(response => {
        const blob = new Blob([response.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `country_system_at_a_glance-${new Date(Date.now()).toISOString()}.xlsx`);
      });
  }
}
